module.exports = __webpack_public_path__ + "static/media/title-ambassador-mobile.cf4e9eb7.png";